// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"ff85e74c","149":"ef1da424","233":"e873464a","293":"313a4c1c","437":"cbfc8757","549":"9ad99906","593":"8efa50e2","642":"91ab59b2","699":"d9b23a42","856":"8d91ef18"}[chunkId] + ".chunk.js";
};